const MeauxminyEpsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">EP (Placement)</p>
            <a href="https://open.spotify.com/album/4b2bNbXYAxIWvz7g6pVYVB?si=7sb-59arR8iVOlfhCj6zpA" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-KSDnl3ihOK4mzmJM-n6cKLQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - MEAUXGEIST (Hellscape Halloween Vol. 1)</strong><br/>
                (prod. Meauxminy & Geist)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/3FnMNXZKI0d9Z4LQtG6M6I" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27377a9b7f3ca027fd52c0fe176" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Genesis</strong><br/>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default MeauxminyEpsStatic;